import api from "../../api/api";
import { toast } from "react-toastify";
import {
  FETCH_EXECUTIVE_REQUESTS_REQUEST,
  FETCH_EXECUTIVE_REQUESTS_SUCCESS,
  FETCH_EXECUTIVE_REQUESTS_FAILURE,
  FETCH_EXECUTIVE_REQUEST_DETAILS_REQUEST,
  FETCH_EXECUTIVE_REQUEST_DETAILS_SUCCESS,
  FETCH_EXECUTIVE_REQUEST_DETAILS_FAILURE,
  ADD_EXECUTIVE_REQUEST_REQUEST,
  ADD_EXECUTIVE_REQUEST_SUCCESS,
  ADD_EXECUTIVE_REQUEST_FAILURE,
  ADD_APPROVE_REQUEST_REQUEST,
  ADD_APPROVE_REQUEST_SUCCESS,
  ADD_APPROVE_REQUEST_FAILURE,
  ADD_ATTEST_REQUEST_REQUEST,
  ADD_ATTEST_REQUEST_SUCCESS,
  ADD_ATTEST_REQUEST_FAILURE,
  ADD_VERIFY_REQUEST_REQUEST,
  ADD_VERIFY_REQUEST_SUCCESS,
  ADD_VERIFY_REQUEST_FAILURE,
  ADD_REJECT_REQUEST_REQUEST,
  ADD_REJECT_REQUEST_SUCCESS,
  ADD_REJECT_REQUEST_FAILURE,
  ADD_PAY_REQUEST_REQUEST,
  ADD_PAY_REQUEST_SUCCESS,
  ADD_PAY_REQUEST_FAILURE,
  ADD_QUERY_REQUEST_REQUEST,
  ADD_QUERY_REQUEST_SUCCESS,
  ADD_QUERY_REQUEST_FAILURE,
  FETCH_EXECUTIVE_VOUCHERS_REQUEST,
  FETCH_EXECUTIVE_VOUCHERS_SUCCESS,
  FETCH_EXECUTIVE_VOUCHERS_FAILURE,
  CLEAR_EXECUTIVE_REQUESTS_ERROR,
  UPDATE_EXECUTIVE_REQUEST_REQUEST,
  UPDATE_EXECUTIVE_REQUEST_SUCCESS,
  UPDATE_EXECUTIVE_REQUEST_FAILURE,
  SUBMIT_EXECUTIVE_REQUEST_REQUEST,
  SUBMIT_EXECUTIVE_REQUEST_SUCCESS,
  SUBMIT_EXECUTIVE_REQUEST_FAILURE,
} from "./executiveRequestActionTypes";

const handleError = (error, context) => {
  console.error(`API - ${context} error:`, error);
  if (error.response) {
    const { status, data } = error.response;
    switch (status) {
      case 400:
        return data.message || "Bad request. Please check your input.";
      case 401:
        localStorage.clear();
        window.location.href = "/";
        return "Session expired. Please log in again.";
      case 403:
        return "You do not have permission to perform this action.";
      case 404:
        return "Requested resource not found.";
      case 409:
        return data.message || "Request already exists.";
      case 500:
        return "Server error. Please try again later.";
      default:
        return data.message || "An unknown error occurred.";
    }
  }
  if (error.request) {
    return "No response received from the server. Please try again later.";
  }
  return error.message || "An unknown error occurred.";
};

export const addExecutiveRequest = (requestData) => async (dispatch) => {
  dispatch({ type: ADD_EXECUTIVE_REQUEST_REQUEST });
  const requestBody = {
    currency: requestData.currency,
    amount: requestData.amount,
    purpose: requestData.purpose,
    userId: requestData.userId,
    isOnSaved: requestData.isOnSaved,
    requestTypeId: requestData.requestType,
  };

  try {
    console.log("API - addExecutiveRequest with body:", requestBody);
    const response = await api.post("/Executive", requestBody, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    console.log("API - addExecutiveRequest response:", response.data);
    dispatch({ type: ADD_EXECUTIVE_REQUEST_SUCCESS, payload: response.data });
    toast.success("Executive request created successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "addExecutiveRequest");
    dispatch({ type: ADD_EXECUTIVE_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const updateExecutiveRequest =
  (requestId, requestData) => async (dispatch) => {
    dispatch({ type: UPDATE_EXECUTIVE_REQUEST_REQUEST });
    const requestBody = {
      id: requestId,
      currency: requestData.currency,
      amount: requestData.amount,
      purpose: requestData.purpose,
      userId: requestData.userId,
      isOnSaved: requestData.isOnSaved,
      requestTypeId: requestData.requestType,
    };

    try {
      console.log("API - updateExecutiveRequest with body:", requestBody);
      const response = await api.put(`/Executive/${requestId}`, requestBody, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      console.log("API - updateExecutiveRequest response:", response.data);
      dispatch({
        type: UPDATE_EXECUTIVE_REQUEST_SUCCESS,
        payload: response.data,
      });
      toast.success("Executive request updated successfully");
      return response.data;
    } catch (error) {
      const errorMessage = handleError(error, "updateExecutiveRequest");
      dispatch({
        type: UPDATE_EXECUTIVE_REQUEST_FAILURE,
        payload: errorMessage,
      });
      toast.error(errorMessage);
      throw error;
    }
  };

export const fetchExecutiveRequests = () => async (dispatch) => {
  dispatch({ type: FETCH_EXECUTIVE_REQUESTS_REQUEST });
  try {
    console.log("API - fetchExecutiveRequests");
    const response = await api.get("/Executive", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    console.log("API - fetchExecutiveRequests response:", response.data);
    dispatch({
      type: FETCH_EXECUTIVE_REQUESTS_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "fetchExecutiveRequests");
    dispatch({ type: FETCH_EXECUTIVE_REQUESTS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchExecutiveRequestDetails = (requestId) => async (dispatch) => {
  dispatch({ type: FETCH_EXECUTIVE_REQUEST_DETAILS_REQUEST });
  try {
    console.log("API - fetchExecutiveRequestDetails for requestId:", requestId);
    const response = await api.get(`/Executive/${requestId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    console.log("API - fetchExecutiveRequestDetails response:", response.data);
    dispatch({
      type: FETCH_EXECUTIVE_REQUEST_DETAILS_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "fetchExecutiveRequestDetails");
    dispatch({
      type: FETCH_EXECUTIVE_REQUEST_DETAILS_FAILURE,
      payload: errorMessage,
    });
    toast.error("Failed to fetch executive request details: " + errorMessage);
    throw error;
  }
};

export const approveExecutiveRequest = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_APPROVE_REQUEST_REQUEST });
  try {
    console.log("API - approveExecutiveRequest for requestId:", requestId);
    const response = await api.put(
      `/Executive/approve/${requestId}`,
      {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      },
    );
    console.log("API - approveExecutiveRequest response:", response.data);
    dispatch({ type: ADD_APPROVE_REQUEST_SUCCESS, payload: response.data });
    toast.success("Executive request approved successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "approveExecutiveRequest");
    dispatch({ type: ADD_APPROVE_REQUEST_FAILURE, payload: errorMessage });
    toast.error("Failed to approve executive request: " + errorMessage);
    throw error;
  }
};

export const attestExecutiveRequest = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_ATTEST_REQUEST_REQUEST });
  try {
    console.log("API - attestExecutiveRequest for requestId:", requestId);
    const response = await api.put(
      `/Executive/attest/${requestId}`,
      {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      },
    );
    console.log("API - attestExecutiveRequest response:", response.data);
    dispatch({ type: ADD_ATTEST_REQUEST_SUCCESS, payload: response.data });
    toast.success("Executive request attested successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "attestExecutiveRequest");
    dispatch({ type: ADD_ATTEST_REQUEST_FAILURE, payload: errorMessage });
    toast.error("Failed to attest executive request: " + errorMessage);
    throw error;
  }
};

export const verifyExecutiveRequest = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_VERIFY_REQUEST_REQUEST });
  try {
    console.log("API - verifyExecutiveRequest for requestId:", requestId);
    const response = await api.put(
      `/Executive/verify/${requestId}`,
      {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      },
    );
    console.log("API - verifyExecutiveRequest response:", response.data);
    dispatch({ type: ADD_VERIFY_REQUEST_SUCCESS, payload: response.data });
    toast.success("Executive request verified successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "verifyExecutiveRequest");
    dispatch({ type: ADD_VERIFY_REQUEST_FAILURE, payload: errorMessage });
    toast.error("Failed to verify executive request: " + errorMessage);
    throw error;
  }
};

export const rejectExecutiveRequest = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_REJECT_REQUEST_REQUEST });
  try {
    console.log("API - rejectExecutiveRequest for requestId:", requestId);
    const response = await api.put(
      `/Executive/reject/${requestId}`,
      {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      },
    );
    console.log("API - rejectExecutiveRequest response:", response.data);
    dispatch({ type: ADD_REJECT_REQUEST_SUCCESS, payload: response.data });
    toast.success("Executive request rejected successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "rejectExecutiveRequest");
    dispatch({ type: ADD_REJECT_REQUEST_FAILURE, payload: errorMessage });
    toast.error("Failed to reject executive request: " + errorMessage);
    throw error;
  }
};

export const payExecutiveRequest =
  (requestId, paymentCode, requiresReceipt, userId) => async (dispatch) => {
    dispatch({ type: ADD_PAY_REQUEST_REQUEST });
    try {
      console.log("API - payExecutiveRequest payload:", {
        requestId,
        paymentCode,
        requiresReceipt,
      });
      const response = await api.post(
        `/Executive/pay?userId=${userId}`,
        {
          requestId,
          paymentCode,
          requiresReceipt,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      );
      console.log("API - payExecutiveRequest response:", response.data);
      dispatch({ type: ADD_PAY_REQUEST_SUCCESS, payload: response.data });
      toast.success("Executive request paid successfully");
      return response.data;
    } catch (error) {
      const errorMessage = handleError(error, "payExecutiveRequest");
      dispatch({ type: ADD_PAY_REQUEST_FAILURE, payload: errorMessage });
      toast.error("Failed to pay executive request: " + errorMessage);
      throw error;
    }
  };

export const queryExecutiveRequestComment = (payload) => async (dispatch) => {
  dispatch({ type: ADD_QUERY_REQUEST_REQUEST });
  try {
    console.log("API - queryExecutiveRequestComment with payload:", payload);
    const response = await api.post(`/Executive/query`, payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    console.log("API - queryExecutiveRequestComment response:", response.data);
    dispatch({ type: ADD_QUERY_REQUEST_SUCCESS, payload: response.data });
    toast.success("Executive request queried successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "queryExecutiveRequestComment");
    dispatch({ type: ADD_QUERY_REQUEST_FAILURE, payload: errorMessage });
    toast.error("Failed to query executive request: " + errorMessage);
    throw error;
  }
};

export const fetchExecutiveRequestVouchers =
  (voucherId, paymentCode, documentType) => async (dispatch) => {
    dispatch({ type: FETCH_EXECUTIVE_VOUCHERS_REQUEST });
    try {
      if (!voucherId || isNaN(voucherId)) {
        throw new Error("Invalid voucherId");
      }
      if (
        !documentType ||
        typeof documentType !== "string" ||
        documentType.trim() === ""
      ) {
        throw new Error("Invalid or missing documentType");
      }
      const cleanDocumentType = documentType.trim();
      const cleanVoucherId = String(voucherId).trim();
      const url = `/Executive/view-voucher/${cleanVoucherId}?documentType=${decodeURIComponent(cleanDocumentType)}`;
      console.log("API - fetchExecutiveVouchers URL:", url);
      const response = await api.get(url, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "*/*",
        },
      });
      console.log("API - fetchExecutiveVouchers response:", {
        status: response.status,
        headers: response.headers,
        dataType: response.data.type,
        dataSize: response.data.size,
      });

      if (!response.data || response.data.size === 0) {
        throw new Error("No PDF data received from the server");
      }
      if (response.data.type !== "application/pdf") {
        throw new Error(
          `Invalid response type: expected application/pdf, got ${response.data.type}`,
        );
      }

      const pdfUrl = URL.createObjectURL(response.data);
      const filename =
        response.headers["content-disposition"]?.match(
          /filename=(?:"([^"]+)"|(\S+))/,
        )?.[1] || `Executive_${paymentCode}.pdf`;
      const payload = { url: pdfUrl, filename };

      dispatch({ type: FETCH_EXECUTIVE_VOUCHERS_SUCCESS, payload });
      return payload;
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - fetchExecutiveVouchers error:", errorMessage);
      if (error.response?.status === 404) {
        console.warn(
          "API - fetchExecutiveVouchers: Voucher not found, returning empty payload",
        );
        const payload = { url: null, filename: null };
        dispatch({ type: FETCH_EXECUTIVE_VOUCHERS_SUCCESS, payload });
        return payload;
      }
      dispatch({
        type: FETCH_EXECUTIVE_VOUCHERS_FAILURE,
        payload: errorMessage,
      });
      toast.error(errorMessage);
      throw error;
    }
  };

export const submitExecutiveRequest = (requestId) => async (dispatch) => {
  dispatch({ type: SUBMIT_EXECUTIVE_REQUEST_REQUEST });
  try {
    console.log("API - submitExecutiveRequest requestId:", requestId);
    const response = await api.post(
      `/Executive/submit/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - submitExecutiveRequest response:", response.data);
    dispatch({
      type: SUBMIT_EXECUTIVE_REQUEST_SUCCESS,
      payload: response.data,
    });
    toast.success("Executive request submitted successfully.");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - submitExecutiveRequest error:", errorMessage);
    dispatch({ type: SUBMIT_EXECUTIVE_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const clearExecutiveRequestsError = () => ({
  type: CLEAR_EXECUTIVE_REQUESTS_ERROR,
});
